// Supabase client configuration
// Environment variables are validated at startup to fail fast with clear errors
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';
import { sharedCookieStorage } from '@/core/auth/cookie-storage';

const SUPABASE_URL = import.meta.env.VITE_SUPABASE_URL;
const SUPABASE_PUBLISHABLE_KEY = import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY;

// Validate environment variables at startup
// This ensures clear error messages instead of cryptic runtime failures
if (!SUPABASE_URL) {
  throw new Error(
    'Missing VITE_SUPABASE_URL environment variable. ' +
    'Ensure this is set in your .env file or Vercel project settings.'
  );
}

if (!SUPABASE_PUBLISHABLE_KEY) {
  throw new Error(
    'Missing VITE_SUPABASE_PUBLISHABLE_KEY environment variable. ' +
    'Ensure this is set in your .env file or Vercel project settings. ' +
    'Note: This should be the Supabase "anon" public key.'
  );
}

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    // Session lives in cookies on .radiologylive.ai so one login covers every
    // RadiologyLive web product. See core/auth/cookie-storage.ts.
    storage: sharedCookieStorage,
    persistSession: true,
    autoRefreshToken: true,
  }
});